<template>
  <div>
    <b-tabs>
      <b-tab class="tab-margin" v-if="isSeller() || isAdmin()" title="通常商品">
        <item-registration :deposit="deposit" :requireDeposit="requireDeposit" :isWarnDeposit="isWarnDeposit"/>
      </b-tab>
      <b-tab class="tab-margin" v-if="isSeller() || isAdmin()" title="セット商品">
        <item-set-registration :deposit="deposit" :requireDeposit="requireDeposit" :isWarnDeposit="isWarnDeposit"/>
      </b-tab>
      <b-tab class="tab-margin" v-if="isSeller() || isAdmin()" title="セット商品管理">
        <item-registration-manage/>
      </b-tab>
    </b-tabs>
    <b-modal ref="messageWithHeader" :title="popupTitle" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" ok-only>
      <div class="text-center">{{confirmMessageSimple}}</div>
    </b-modal>
  </div>
  
</template>

<script>
import Vue from 'vue';
import BaseView from '@/views/BaseView';
import ItemRegistration from '@/components/item-registration/ItemRegistration';
import ItemSetRegistration from '@/components/item-registration/ItemSetRegistration';
import ItemRegistrationManage from '@/components/item-registration/ItemRegistrationManage';
import * as api from '@/api';

export default {
  mixins: [BaseView],
  data() {
    return {
      deposit: 0,
      requireDeposit: 0,
      isWarnDeposit: false,
      isRestrictStock: false,
      popupTitle: '',
      confirmMessageSimple: ''
    }
  },
  created() {
    this.updateTitle('LAS登録');
    api.getInitialDepositInfo((data) => {
      this.deposit = data.deposit;
      this.requireDeposit = data.requireDeposit;
      this.isWarnDeposit = data.isWarnDeposit;
      this.isRestrictStock = data.isRestrictStock;

      if(this.isRestrictStock){
        this.popupTitle = '注意事項'
        this.confirmMessageSimple = 'Amazon在庫補充制限の為発送できません';
        this.$refs.messageWithHeader.show();
      }
    });
  },
};

Vue.component('item-registration', ItemRegistration);
Vue.component('item-set-registration', ItemSetRegistration);
Vue.component('item-registration-manage', ItemRegistrationManage);
</script>

<style>
.tab-margin {
  margin-top: 1rem;
}
</style>
